<template>
  <div class="seat-row-item">
    <div class="seat-col" v-for="(col, index) in seatRow" :key="index">
      <!--紧急出口-->
      <div class="exit" v-if="col.col === ' '"></div>
      <!--通道-->
      <div class="seat-num" v-else-if="col.col == '='">{{col.row}}</div>
      <!--座位-->
      <div
        class="seat"
        ref="seat"
        v-else
        :class="col.styleClass"
        :data-seat="col.seatNumber"
        @click="handleSelect($event, col)"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    seatRow: Array
  },
  methods: {
    handleSelect (event, col) {
      let flag = false
      if (col.styleClass.indexOf('icon2-seats-ordinary') >= 0 && col.styleClass.indexOf('seat-checked-fellow') < 0) {
        flag = true
      }
      if (flag) {
        const emptySeatClass = 'icon2 icon2-seats-ordinary'
        this.$set(col, 'styleClass', `${emptySeatClass} seat-checked`)
        this.$emit('selectSeat', col.seatNumber)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.seat-row-item {
  display: flex;
  flex-direction: column-reverse;
}
.seat-col {
  .seat {
    width: 18px;
    height: 18px;
    margin: 3px 0;
    background: url(../img/seat3.png) 100% no-repeat;
  }
  .seat-num {
    width: 18px;
    height: 18px;
    margin: 3px 0;
    font-size: 14px;
    text-align: center;
  }
  /* 最舒适座位 */
  .seat.icon2-seats-comfort {
    background-image: url(../img/seat1.png);
  }
  /* 最受欢迎座位 */
  .seat.icon2-seats-okay {
    background-image: url(../img/seat2.png);
  }
  /* 普通座位 */
  .seat.icon2-seats-ordinary {
    background-image: url(../img/seat3.png);
    cursor: pointer;
  }
  /* 已被他人值机座位 */
  .seat.icon2-seats-select {
    background-image: url(../img/seat4.png);
  }
  /* 不能值机座位 */
  .seat.icon2-seats-exit {
    background-image: url(../img/seat5.png);
  }
  /* 自己选中的座位 */
  .seat.seat-checked {
    background-image: url(../img/seat6.png);
  }
  /* 同程选中的座位 */
  .seat.seat-checked-fellow {
    background-image: url(../img/seat6.png);
    opacity: .7;
  }
  .exit:nth-child(1) {
    position: relative;
  }
}
@media only screen and (max-width: 768px) {
  .airplane-type-330 {
    .seat-col {
      .seat-num {
        width: 23px;
        height: 23px;
      }
      .seat {
        width: 23px;
        height: 23px;
      }
    }
  }
  .seat-col {
    .seat-num {
      width: 30px;
      height: 30px;
      margin: 3px;
      font-size: 16px;
      text-align: center;
      line-height: 30px;
    }
    .seat {
      width: 30px;
      height: 30px;
      margin: 3px;
      background: url(../img/seat3_m.png) 100% no-repeat;
      background-size: 100%;
    }
    /* 最舒适座位 */
    .seat.icon2-seats-comfort {
      background-image: url(../img/seat1_m.png);
    }
    /* 最受欢迎座位 */
    .seat.icon2-seats-okay {
      background-image: url(../img/seat2_m.png);
    }
    /* 普通座位 */
    .seat.icon2-seats-ordinary {
      background-image: url(../img/seat3_m.png);
      cursor: pointer;
    }
    /* 已被他人值机座位 */
    .seat.icon2-seats-select {
      background-image: url(../img/seat4_m.png);
    }
    /* 不能值机座位 */
    .seat.icon2-seats-exit {
      background-image: url(../img/seat5_m.png);
    }
    /* 自己选中的座位 */
    .seat.seat-checked {
      background-image: url(../img/seat6_m.png);
    }
  }
}
</style>
